
import * as _ from 'lodash';
import { Task } from './task';
import { User } from './User';


export class TaskUser {
  public id: number = null
  public user_id: number = null // mission id
  public task_id: string = null;
  public last_answered_question_id: string = null;
  public status: string = null;
  public assigned_date: string = null;
  public deadline_date: string = null;
  public check_date: string = null;
  public reject_reason: number = null;
  public notif_urgent: number = null;
  public notif_soon: number = null;
  public notif_expired: string = null;
  public paid_at: string = null;
  public issue_description: string = null;
  public issue_photo: string = null;
  
  public task: Task = null;
  public user: User = null;

  constructor(id?: number | Object) {
    if (typeof id == 'object') {
      this.import(id);
    } else {
      this.id = id;
    }
  }

  exists() {
    return this.id != null;
  }

  import(data) {
    for (var key in data) {
      if (this.hasOwnProperty(key)) {
        switch (key) {
          case 'task':
            this.task = new Task(data[key]);
            break;
          case 'user':
            this.user = new User(data[key]);
          break;
          default:
            this[key] = data[key];
        }
      }
    }
  }

}
